import { FileTypeConst } from '@/common/types/Files.type';
import { GetDamagedVehicleCorrectiveImagesFormTabsParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getDamagedVehicleCorrectiveImagesFormTabs.type';
import { getDamagedVehicleCorrectiveImagesFormTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getDamagedVehicleCorrectiveImagesFormTabsFunction';
import { getInitialVisitCorrectiveImagesFormTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImagesFormTabs/getInitialVisitCorrectiveImagesFormTabsFunction';
import { queryOptions } from '@tanstack/react-query';

const getDamagedVehicleCorrectiveImagesFormTabsOptions = (
  params: GetDamagedVehicleCorrectiveImagesFormTabsParamsType,
  typeRequest?: FileTypeConst,
) => {
  const queryFn = () => {
    if (typeRequest && typeRequest === 'initial') {
      return getInitialVisitCorrectiveImagesFormTabsFunction(params);
    }
    return getDamagedVehicleCorrectiveImagesFormTabsFunction(params);
  };
  return queryOptions({
    queryKey: ['GET_DAMAGED_VEHICLE_CORRECTIVE_IMAGE_FORM_TABS_', params],
    queryFn: () => queryFn(),
  });
};
export default getDamagedVehicleCorrectiveImagesFormTabsOptions;
